import { Link } from './Router.tsx'

export const Logo = () => (
  <h1 className="text-[2em] md:text-[2.5em] relative mr-[-8px] top-[0px] left-[0px] font-extrabold font-[Turret_Road] bg-gradient-to-br from-orange-400 to-red-600 bg-clip-text text-transparent cursor-pointer hover:opacity-90">
    <Link href="/">loopmaster</Link>
  </h1>
)
